import * as React from "react";

import Alert from "@mui/material/Alert";


export default function MessageDisplay({ messages }) {
  const [open, setOpen] = React.useState(messages.map(() => true));

  const handleClose = (index) => {
    const updatedOpen = [...open];
    updatedOpen[index] = false;
    setOpen(updatedOpen);
  };

  const alertMes = messages.map((mes) => {
    switch (mes.type) {
      case 0:
        return { message: mes.message, type: "info" };
        break;
      case 1:
        return { message: mes.message, type: "success" };
        break;
      case 2:
        return { message: mes.message, type: "warning" };
        break;
      case 3:
        return { message: mes.message, type: "error" };
        break;
    }
  });

  return (
    <>
      {alertMes.map((mes, index) => (
        <div key={index}>
          {open[index] ? (
            <Alert
              severity={mes.type}
              onClose={() => handleClose(index)}
              sx={{ mt: 1, mb: 1 }}
            >
              {mes.message}
            </Alert>
          ) : null}
        </div>
      ))}
    </>
  );
}
